import { useRecoilValue } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import useGoogleLoginV2 from "../../hooks/useGoogleLoginV2";
import LoginButtonTemplatePromotion from "./LoginButtonTemplatePromotion";
import useMixpanelMKT from "../../hooks/useMixpanelMKT";

export default function GoogleLoginButtonPromotion({
  render,
  referralCode,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
  // 제휴(레퍼럴) 진입일 때의 코드. 없으면 일반 프로모션 로그인이다.
  referralCode?: string;
}) {
  const user = useRecoilValue(userSimpleAtom);
  const { handleGoogleLogin, isLoading } = useGoogleLoginV2(referralCode);

  const trackLoginButtonClick = useMixpanelMKT({
    eventName: "로그인 버튼 클릭",
    params: { method: "google" },
    version: "v4",
  });

  return (
    <LoginButtonTemplatePromotion
      loginType="google"
      action={() => {
        trackLoginButtonClick();
        handleGoogleLogin();
      }}
      isLoggedIn={!!user?.accessToken}
      isLoading={isLoading}
    />
  );
}
